import TableDetails from './TableDetail';
export default TableDetails;